import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { Sector } from 'src/app/models/obs/sector';
import { SectorService } from 'src/app/services/obs/sector.service';
import { BridgeService } from '../../../services/util/bridge.service';


@Component({
  selector: 'app-sectorial',
  templateUrl: './sectorial.component.html',
  styleUrl: './sectorial.component.scss'
})
export class SectorialComponent implements OnInit {

  msg: Message;
  filteredSector: Sector[] = [];
  isParentComponent: boolean = false;
  selectedSectorId: string | null = null;
  idTier1: number = 13;

  constructor(
    private sectorService: SectorService,
    private bridgeService: BridgeService
  ) { }

  ngOnInit() {
    this.bridgeService.selectedSectorId$.subscribe(sectorId => {
      this.selectedSectorId = sectorId;
    });
    this.getAllSectors()
  }


  getAllSectors() {
    this.sectorService.getAllOnlyT3().subscribe(
      res => {
        this.filteredSector = res['data'];
      },
      err => { this.msg = err; }
    );
  }
}

